import { Anchor, Box, Text } from '@inflearn/ds-react-next';
import { useTranslateComponent } from '@inflearn/i18n-tools';
import { useTranslation } from 'react-i18next';

export function VerificationNotice() {
  const { t } = useTranslation();

  const GuideText = useTranslateComponent({
    en: <>{t('인증 코드를 받지 못하셨다면 다시 한 번 시도해 주세요.')}</>,
    ko: (
      <Anchor
        href={`https://www.inflearn.com/faq#:~:${[
          '번호인증',
          '스팸필터링',
          '스팸차단서비스',
          '스팸차단',
        ]
          .map((keyword) => `text=${encodeURIComponent(keyword)}`)
          .join('&')}`}
        target="_blank"
        rel="noopener noreferrer"
        c="blue.6"
        styles={{
          root: {
            textDecoration: 'underline',
          },
        }}
      >
        {t('인증번호를 못 받으셨나요? 스팸 차단 확인 방법')}
      </Anchor>
    ),
  });

  return (
    <Box>
      <Text size="sm" c="gray.6">
        {t('phone_verification.code_sent_by_sms')} <br />
      </Text>
      <Text size="sm" c="gray.6">
        {GuideText}
      </Text>
    </Box>
  );
}
